import { PencilSquareIcon } from '@heroicons/react/24/outline';
import { Handle, Position } from '@xyflow/react';

import ClipFinalPreview from './ClipFinalPreview';
import type { ClipContextNodeData } from '../types';

interface ClipContextNodeProps {
  data: ClipContextNodeData;
}

export default function ClipContextNode({ data }: ClipContextNodeProps) {
  const clip = data.videoClip;
  const title = clip.title || clip.sceneName || '未命名片段';
  const metaItems = [
    clip.speaker ? `角色：${clip.speaker}` : null,
    clip.sceneName ? `场景：${clip.sceneName}` : null,
    clip.duration != null ? `时长：${clip.duration}s` : null,
  ].filter(Boolean);
  const shotItems = [
    clip.structure ? `构图：${clip.structure}` : null,
    clip.cameraWork ? `运镜：${clip.cameraWork}` : null,
    clip.transition ? `转场：${clip.transition}` : null,
  ].filter(Boolean);

  return (
    <div className="clip-canvas-node clip-canvas-node--context">
      <Handle type="source" position={Position.Right} />
      <div className="clip-canvas-node__topline">
        <div className="clip-canvas-node__eyebrow">Clip #{clip.sequence ?? '-'}</div>
        <button
          type="button"
          className="clip-canvas-node__icon-button nodrag nopan"
          onClick={(event) => {
            event.stopPropagation();
            data.actions.onEditNode?.(`clip:${clip.id}`);
          }}
          aria-label="编辑分镜属性"
          title="编辑分镜属性"
        >
          <PencilSquareIcon className="h-4 w-4" />
        </button>
      </div>
      <div className="clip-canvas-node__title">{title}</div>
      {metaItems.length > 0 && (
        <div className="clip-canvas-node__chips">
          {metaItems.map((item) => (
            <span key={item} className="clip-canvas-node__chip">{item}</span>
          ))}
        </div>
      )}
      {clip.description && (
        <div className="clip-canvas-node__section">
          <div className="clip-canvas-node__section-label">画面</div>
          <div className="clip-canvas-node__text">{clip.description}</div>
        </div>
      )}
      {clip.script && (
        <div className="clip-canvas-node__section">
          <div className="clip-canvas-node__section-label">台词</div>
          <div className="clip-canvas-node__script">{clip.script}</div>
        </div>
      )}
      {shotItems.length > 0 && (
        <div className="clip-canvas-node__shot-list">
          {shotItems.map((item) => (
            <div key={item} className="clip-canvas-node__shot-item">{item}</div>
          ))}
        </div>
      )}

      <ClipFinalPreview clip={clip} />
    </div>
  );
}
